import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.14 13.328a.427.427 0 0 1 .573-.633l3.88 3.518 8.67-9.08a.427.427 0 1 1 .62.59l-8.959 9.38a.427.427 0 0 1-.596.022L5.14 13.328Z",
  fill: "#fff"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };